import { useEffect, useRef, useState } from "react";
import { Editor as EditorNew } from "@tinymce/tinymce-react";
import ModalMidiaFile from "../Forms/components/ModalMediaFileSelect";

const TYNE_TOKEN = process.env.REACT_APP_TINY_TOKEN;
const API_IMAGE_URL = process.env.REACT_APP_API_IMAGE_URL;
const ALLOWED_DOMAINS: string[] = [API_IMAGE_URL];

export function Editor({
  value,
  onChange,
  basic = false,
  placeholder,
  enabled = false,
}: {
  value: string;
  onChange: (value: string) => void;
  ref?: any;
  basic?: boolean;
  placeholder?: string;
  enabled?: boolean;
}) {
  const [valueEditor, setValueEditor] = useState<string>(value);
  useEffect(() => {
    if (valueEditor !== undefined && valueEditor !== null) {
      onChange(valueEditor);
    }
  }, [valueEditor]);

  const editorRef = useRef(null);
  const [open, setOpen] = useState(false);

  const handleSelectImage = ({ url, name }: { url: string; name?: string }) => {
    if (editorRef.current) {
      const editor = editorRef.current;
      editor.insertContent(`<img src="${url}" alt="${name || "Imagem"}" />`);
      setOpen(false);
    }
  };

  return (
    <>
      <EditorNew
        apiKey={TYNE_TOKEN}
        onInit={(_evt, editor) => {
          editorRef.current = editor;

          // Custon plugin to image
          editor.ui.registry.addButton("imageModal", {
            icon: "image",
            onAction: () => setOpen(true),
          });

          editor.ui.registry.addMenuItem("imageModal", {
            text: "Inserir Imagem",
            icon: "image",
            onAction: () => setOpen(true),
          });
        }}
        value={valueEditor}
        onEditorChange={(content: string) => {
          setValueEditor(content);
        }}
        disabled={!enabled}
        init={{
          height: 500,
          menubar: true,
          placeholder: placeholder,
          plugins: [
            "advlist",
            "autolink",
            "lists",
            "link",
            "charmap",
            "preview",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            "fullscreen",
            "insertdatetime",
            "code",
            "help",
            "wordcount",
          ].concat(basic ? [] : ["imageModal", "media"]),
          toolbar:
            `undo redo | blocks | ${basic ? "" : "imageModal |"}` +
            "bold italic forecolor | alignleft aligncenter " +
            "alignright alignjustify | bullist numlist outdent indent | " +
            "removeformat | help ",
          menu: basic
            ? undefined
            : {
                insert: {
                  title: "Inserir",
                  items: "link media imageModal charmap hr anchor insertdatetime",
                },
              },
          paste_preprocess: (plugin, args) => {
            //REMOVE IMAGES NOT ALLOWEDS
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = args.content;
            const images = tempDiv.getElementsByTagName("img");

            for (let img of images) {
              const src = img.getAttribute("src");
              if (!src || !ALLOWED_DOMAINS.some((domain) => src.startsWith(domain))) {
                img.remove();
              }
            }

            args.content = tempDiv.innerHTML;
          },

          content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
        }}
      />
      <br />
      {enabled && (
        <ModalMidiaFile
          fileType="IMAGES"
          onClickMidia={handleSelectImage}
          onClose={() => setOpen(false)}
          open={open}
        />
      )}
    </>
  );
}
